import { cn } from '@foam/buoy/src/lib/utils';
import * as React from 'react';
import { SharedFooter } from 'ui-components';

export interface SharedLayoutProps {
  children?: React.ReactNode;
  topBar?: React.ReactNode;
  variant?: 'compact' | 'restricted' | 'fluid';
}

export const SharedLayout: React.FC<SharedLayoutProps> = ({
  children,
  topBar,
  variant = 'fluid',
}) => (
  <div className="flex min-h-screen flex-col items-stretch">
    <main className="relative flex flex-1 flex-col items-stretch overflow-visible bg-neutral-0">
      {topBar}
      <div
        className={cn('mx-auto w-full', {
          'max-w-[63rem]': variant === 'compact',
          'max-w-[90rem]': variant === 'restricted',
        })}
      >
        {children}
      </div>
    </main>
    <SharedFooter />
  </div>
);
